import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import Icon from './Icon.svelte';

export default function TrendingDown($$anchor, $$props) {
	const iconNode = [
		["path", { "d": "M16 17h6v-6" }],
		["path", { "d": "m22 17-8.5-8.5-5 5L2 7" }]
	];

	let rest = $.rest_props($$props, ['$$slots', '$$events', '$$legacy']);

	Icon($$anchor, $.spread_props(
		{
			get iconNode() {
				return iconNode;
			}
		},
		() => rest
	));
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiVHJlbmRpbmdEb3duLnN2ZWx0ZSJdLCJzb3VyY2VzQ29udGVudCI6WyI8c2NyaXB0IGxhbmc9XCJ0c1wiPlxuICBpbXBvcnQgSWNvbiBmcm9tICcuL0ljb24uc3ZlbHRlJztcbiAgY29uc3QgaWNvbk5vZGU6IFtzdHJpbmcsIFJlY29yZDxzdHJpbmcsIHN0cmluZz5dW10gPSBbW1wicGF0aFwiLCB7IFwiZFwiOiBcIk0xNiAxN2g2di02XCIgfV0sIFtcInBhdGhcIiwgeyBcImRcIjogXCJtMjIgMTctOC41LTguNS01IDVMMiA3XCIgfV1dO1xuICBsZXQgcmVzdCA9ICRwcm9wcygpO1xuPC9zY3JpcHQ+XG48SWNvbiB7aWNvbk5vZGV9IHsuLi5yZXN0fSAvPlxuIl0sIm1hcHBpbmdzIjoiOztPQUNTLElBQUksTUFBTSxlQUFlOzt3REFEbEMsQ0FBQztPQUVPLFFBQTRDO0dBQUssTUFBTSxJQUFJLEdBQUcsRUFBRSxhQUFhO0dBQU0sTUFBTSxJQUFJLEdBQUcsRUFBRSx3QkFBd0I7OztLQUM1SCxJQUFJOzs7Ozs7OztRQUVXLElBQUk7O0FBRDFCLENBQUMifQ==